var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{attrs:{"id":_vm.form_id},on:{"submit":function($event){$event.preventDefault();}}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }